import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FooterPositionService {
  user: any = {};
  public dropdownOpenState = new BehaviorSubject<boolean>(false);
  $dropdownOpenState = this.dropdownOpenState.asObservable();

updateDropdownState(isOpen:boolean){
    this.dropdownOpenState.next(isOpen);
}
 
}
